export default __webpack_public_path__ + "static/media/List-documentation.eb3a6250.md";